<template v-model="">
  <v-container class="text-center" fluid>
    
    <!-- <login-box v-if="!$store.getters.isAuthenticated"/> -->

    <WelcomeMobile class="d-sm-none d-block" />
    <!-- <v-card class="d-sm-none d-flex">
      <v-img src="https://www.t4sports.com.br/img/tobias-bike.b1ac3714.jpg" gradient="to bottom, rgba(0,0,0,.6), rgba(0,0,0,.9)">
        <v-card-text class="text-white title">
          <p>Bem-vindo! </p>
          <p>Somos a T4 Sports, uma assessoria esportiva voltada tanto para atletas de alta performance quanto para iniciantes!</p>
          <p>Você já é atleta e precisa de um acompanhamento nos treinos para evoluir mais? Conte conosco!</p>
          <p>Ainda não faz atividade, quer começar mas não sabe como? Venha treinar com a gente!</p>

          <p>Crie sua conta ou faça login aqui no app, e bons treinos!</p>

          <v-btn color="primary" class="mt-3" dark width="100%" link to="/login">
            Vamos lá!
          </v-btn>

        </v-card-text>
      </v-img>
    </v-card> -->

    <WelcomeDesktop class="d-none d-sm-block"/>


  </v-container>
</template>

<script>

// import LoginBox from '../components/LoginBox';
import HOST from '../ws'
import WelcomeDesktop from './desktop/WelcomeDesktop.vue';
import WelcomeMobile from './mobile/WelcomeMobile.vue';

export default {
  components : {
    WelcomeDesktop,
    WelcomeMobile
    // LoginBox,
  },

  props: {
    source: String
  },
  data: () => ({
    
  }),

  beforeMount (){

    //testando se está logado:
    this.axios({
      method: "post",
      url: HOST.HOST + "/user/checktk",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.$store.state.currentToken}`
      },
    })
    .then(response => {
      console.log('logado : ' + response.status);
      this.$router.push("/homeFeed");
    })
    .catch(error => {
      console.log(error.message);
      this.$store.commit("logout");
    });

  },

  methods : {
    
  }
};
</script>